/* Terraloo Sleek — predictive search */
(function () {
  'use strict';

  var input = document.querySelector('[data-tls-predictive-search-input]');
  var resultsEl = document.querySelector('[data-tls-predictive-search-results]');
  if (!input || !resultsEl) return;

  var debounceTimer;
  var currentController;

  function money(cents) {
    if (window.TerralooSleek && window.TerralooSleek.formatMoney) {
      return window.TerralooSleek.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function renderResults(data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    var pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
    var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

    if (!products.length && !collections.length && !pages.length && !articles.length) {
      resultsEl.innerHTML = '<p class="tls-search-empty">' + window.TerralooSleek.strings.noResults.replace('{{ terms }}', query) + '</p>';
      return;
    }

    var html = '';

    if (products.length) {
      html += '<div class="tls-search-group"><h3 class="tls-search-group__title">' + window.TerralooSleek.strings.products + '</h3><ul class="tls-search-product-list">';
      products.forEach(function (p) {
        html +=
          '<li><a href="' +
          p.url +
          '" class="tls-search-product">' +
          (p.featured_image ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy" width="56" height="56">' : '<span class="tls-search-product__ph"></span>') +
          '<span><span class="tls-search-product__title">' +
          p.title +
          '</span><span class="tls-price">' +
          money(p.price) +
          '</span></span></a></li>';
      });
      html += '</ul></div>';
    }

    ['collections', 'pages', 'articles'].forEach(function (key) {
      var list = key === 'collections' ? collections : key === 'pages' ? pages : articles;
      if (!list.length) return;
      html += '<div class="tls-search-group"><h3 class="tls-search-group__title">' + window.TerralooSleek.strings[key] + '</h3><ul class="tls-search-link-list">';
      list.forEach(function (item) {
        html += '<li><a href="' + item.url + '">' + item.title + '</a></li>';
      });
      html += '</ul></div>';
    });

    resultsEl.innerHTML = html;
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (!query) {
      resultsEl.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      if (currentController) currentController.abort();
      currentController = new AbortController();

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page,article&resources[limit]=6', {
        signal: currentController.signal
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          renderResults(data, query);
        })
        .catch(function () {});
    }, 220);
  });
})();
